import style from "./Loader.module.css";

export const Loader = ({ children }) => {
  return (
    <section className={style.emptyState}>
      <div className={style.text}>
        <div className={style.div}>
          <div className={style.textWrapper}>{children || "Loading..."}</div>
          <div className={style.loader}></div>
        </div>
      </div>
    </section>
  );
};
